<div class="fixed-top">
  <nav
    #navbar
    (mouseenter)="mouseEnter()"
    (mouseleave)="mouseLeave()"
    class="navbar icon-nav navbar-expand-lg"
    [class.fill-navbar]="
      alwaysFillNav || fillNav || !navbarCollapsed || hovering
    "
  >
    <div class="d-flex justify-content-between w-100">
      <div class="navbar-brand">
        <a [routerLink]="['/', themeService.brand]">
          <img
            class="brand-logo"
            [src]="
              themeService.brand === 'default'
                ? './assets/img/logotypes/vw.svg'
                : './assets/img/logotypes/' + themeService.brand + '.svg'
            "
            alt="brand logo"
          />

          <img
            class="brand-logo neg"
            [src]="
              themeService.brand === 'default'
                ? './assets/img/logotypes/vw-neg.svg'
                : './assets/img/logotypes/' + themeService.brand + '-neg.svg'
            "
            alt="brand logo"
          />
        </a>
      </div>

      <ul class="navbar-nav ms-auto flex-row align-items-center">
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon d-flex align-items-center pointer pt-1"
            (click)="openSelectDealer($event)"
            ><span class="h6 mb-0 nav-hide-mobile me-2 fw-normal">{{
              "navigation.selectRegNr" | translate
            }}</span>

            <div class="icon-container">
              <i class="fal fa-car-side nav-fa-icon"></i>
              @if (!isCarSelected) {
                <i class="fas fa-exclamation-triangle warning-icon"></i>
              }
            </div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon d-flex align-items-center pointer pt-1"
            (click)="openSelectDealer($event)"
            ><span class="h6 mb-0 nav-hide-mobile me-2 fw-normal">{{
              "navigation.selectDealer" | translate
            }}</span>

            <div class="icon-container">
              <i class="fal fa-garage-car nav-fa-icon"></i>
              @if (!isDealerSelected) {
                <i class="fas fa-exclamation-triangle warning-icon"></i>
              }
            </div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon d-flex align-items-center pt-1"
            [routerLink]="['/', themeService.brand, 'search']"
            ><span class="h6 mb-0 nav-hide-mobile me-2 fw-normal">{{
              "navigation.searchAccessories" | translate
            }}</span>
            <i class="fal fa-search nav-fa-icon"></i
          ></a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon d-flex align-items-center pointer pt-1"
            (click)="openShoppingCart($event)"
            ><span class="h6 mb-0 nav-hide-mobile me-2 fw-normal">{{
              "navigation.shoppingCart" | translate
            }}</span>
            <div class="shopping-cart" *ngIf="shoppingCartService.shoppingCart">
              <span *ngIf="shoppingCartService.totalProductCount !== 0">{{
                shoppingCartService.totalProductCount
              }}</span>
              <i class="fal fa-shopping-cart nav-fa-icon"></i>
            </div>
          </a>
        </li>
      </ul>
      <button
        class="navbar-toggler ms-2 me-3 me-lg-0"
        type="button"
        (click)="toggleNavbar()"
      >
        <i
          class="fal nav-fa-icon"
          [ngClass]="navbarCollapsed ? 'fa-bars' : 'fa-times'"
        ></i>
      </button>
    </div>
    <div
      class="navbar-collapse w-100 justify-content-lg-center"
      [class.collapse]="navbarCollapsed"
    >
      <div class="selected-dealer">
        @if (isCarSelected || isDealerSelected) {
          <span class="title">{{ selectedCarOrDealerLabel }} </span>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <span
                class="reg-nr bold"
                *ngIf="
                  channelRequestService.channelRequest &&
                  channelRequestService.channelRequest.shoppingCart &&
                  channelRequestService.channelRequest.shoppingCart.vehicle
                "
              >
                {{
                  channelRequestService.channelRequest.shoppingCart.vehicle
                    | vehicle
                }}
              </span>
              <span class="dealer" *ngIf="modelAndDealerService.selectedDealer">
                {{ modelAndDealerService.selectedDealer.name }}
              </span>
            </div>
            <i class="fal fa-pen nav-fa-icon" (click)="openSelectDealer()"></i>
          </div>
        }
        @if (!isCarSelected) {
          <a
            class="d-flex align-items-center pointer pt-2 pb-2"
            (click)="openSelectDealer($event)"
            ><span class="nav-button">{{
              "navigation.selectRegNr" | translate
            }}</span></a
          >
        }
        @if (!isDealerSelected) {
          <a
            class="d-flex align-items-center pointer pt-2 pb-2"
            (click)="openSelectDealer($event)"
            ><span class="nav-button">{{
              "navigation.selectDealer" | translate
            }}</span></a
          >
        }
      </div>

      <ul class="navbar-nav" *ngIf="menuLinks">
        <li class="nav-item mt-4 mt-lg-0" *ngFor="let m of menuLinks">
          <div *ngIf="m.catalogCategory">
            <a
              class="nav-link"
              [routerLink]="[
                '/' + themeService.brand,
                'category',
                m.catalogCategory.catalogCategoryId,
                m.href,
              ]"
              routerLinkActive="active"
              >{{ m.text }}
            </a>
            <i
              *ngIf="m.text != null && m.children && active !== m.text"
              class="nav-fa-icon nav-hide-lg fal fa-plus"
              (click)="toggleDropdown($event, m.text)"
            ></i>
            <i
              class="nav-fa-icon nav-hide-lg fal fa-minus"
              (click)="toggleDropdown($event, '')"
              *ngIf="m.children && active === m.text"
            ></i>
          </div>
          <div
            class="nav-dropdown"
            [class.open]="active === m.text"
            *ngIf="m.children && m.children.length > 0"
            routerLinkActive="mobile-open"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <ul class="row list-unstyled ms-2 ms-lg-0 mt-1 mt-lg-0">
              <ng-container *ngFor="let c of m.children; let i = index">
                <li
                  class="nav-dropdown-item col-12 col-lg-2"
                  [class.offset-lg-2]="i === 0"
                >
                  <ng-container *ngIf="c.catalogCategory">
                    <a
                      class="category-title"
                      [routerLink]="[
                        '/' + themeService.brand,
                        'category',
                        c.catalogCategory.catalogCategoryId,
                        c.href,
                      ]"
                      routerLinkActive="active"
                      >{{ c.text }}
                    </a>
                    <ul *ngIf="c.children && c.children.length > 0">
                      <li *ngFor="let l of c.children">
                        <a
                          *ngIf="l.catalogCategory"
                          [routerLink]="[
                            '/' + themeService.brand,
                            'category',
                            l.catalogCategory.catalogCategoryId,
                            l.href,
                          ]"
                          routerLinkActive="active"
                          >{{ l.text }}</a
                        >
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ng-container>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</div>

<vw-expand>
  <vw-shopping-cart></vw-shopping-cart>
  <div footer>
    <span class="pointer text-link" (click)="clearShoppingCart()">{{
      "shoppingCart.clear" | translate
    }}</span>

    <vw-button
      [type]="'button'"
      [primary]="true"
      [text]="'shoppingCart.toCheckout' | translate"
      (click$)="goToCheckout()"
      [disabled]="
        !shoppingCartService.hasItems || !modelAndDealerService.selectedDealer
      "
    ></vw-button>
  </div>
</vw-expand>

<vw-select-dealer></vw-select-dealer>
